// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1SRs9","approved":"Status_approved__bmrTc","rejected":"Status_rejected__gRn3-","expired":"Status_expired__1MhsH","label":"Status_label__21k_D"};